// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6Lbxl","largestCol":"styles_largestCol__1Xpoc","smallestCol":"styles_smallestCol__1FUOn"};